import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";

interface MemberCountProps {
  count?: number;
}

export const MemberCount = ({ count }: MemberCountProps) => {
  if (!count) return null;
  const memberCountLabel =
    count === 1 ? "member_count_singular" : "member_count_plural";

  return (
    <Typography.LabelXxs>
      {t(`community_member_select.${memberCountLabel}`, { count })}
    </Typography.LabelXxs>
  );
};
